import {
  Box, DashboardModule, Link,
} from '@domain-group/suit-theme'

import { useNumericParams } from '@domain-group/react-hooks'

import useCampaign from '@hooks/useCampaign'
import useCurrentUser from '@hooks/useCurrentUser'

import EnabledPermission from '@components/EnabledPermission'

import { getCampaignPermissions, getCampaignType } from '@functions/campaign'
import ImageGridContainer from './ImageGridContainer'

import useCampaignImages from '../../../PhotosAndPlans/screens/List/hooks/useCampaignImages'

const Images = () => {
  const { campaignId } = useNumericParams()

  const campaignImagesPayload = useCampaignImages(campaignId)
  const {
    campaign,
    exportSizeErrorImageIds,
    hasExportSizeErrorImageIds,
    hasPublicImages,
    loading,
    publicImages,
  } = campaignImagesPayload

  const {
    urls: {
      campaignMediaUrl,
    },
  } = useCampaign({ id: campaignId })

  const { currentUser } = useCurrentUser()
  const campaignPermissions = getCampaignPermissions({ user: currentUser, campaignType: getCampaignType(campaign) })
  const { photos_and_plans } = campaignPermissions

  return (
    <DashboardModule
      headerRight={!!photos_and_plans?.manage && (
        <EnabledPermission permissionKey="campaign.media.manage">
          <Link href={campaignMediaUrl} textProps={{ fontSize: 'small' }}>
            Manage
          </Link>
        </EnabledPermission>
      )}
      loading={loading}
      title="Media"
    >
      <Box flexDirection="column">
        {!loading && !hasPublicImages && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>No public media in this campaign</DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              You can upload media in the Photos and Plans page. Once uploaded set the media to Public for them to show
              here and export to portals.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasExportSizeErrorImageIds && hasPublicImages && (
          <DashboardModule.BlankState boxProps={{ paddingBottom: 'small' }}>
            <DashboardModule.BlankState.Title>Some images have export errors</DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Some images have not been resized or watermarked for export. Please toggle them from Public to Private to
              retry the job.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasPublicImages && (
          <ImageGridContainer exportSizeErrorImageIds={exportSizeErrorImageIds} images={publicImages} />
        )}
      </Box>
    </DashboardModule>
  )
}

export default Images
